module.exports = __webpack_public_path__ + "static/homepage-beauty-sections-manager-c8fa678dc407eb1915d9b602e6a12607.png";